// src/lib/date.ts
/** Format a stored date but force the display year to the current year. */
export function formatAsThisYear(dateStr: string, locale = 'en-US') {
    const d = new Date(dateStr);
    // Force the year shown to be "this" year (useful when backfilling older posts)
    const currentYear = new Date().getFullYear();
    d.setFullYear(currentYear);
    return d.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });
  }
  